import SearchItem, {
  CalendarData,
  ContactsData,
  DropboxData,
  SlackData,
  TweetData,
} from '../utils/SearchItem'

const calendarRaw = require('./calendar.json').calendar as CalendarData[]
const contactsRaw = require('./contacts.json').contacts as ContactsData[]
const dropboxRaw = require('./dropbox.json').dropbox as DropboxData[]
const slackRaw = require('./slack.json').slack as SlackData[]
const tweetRaw = require('./tweet.json').tweet as TweetData[]

const CALENDAR = calendarRaw.map((data: CalendarData) => new SearchItem(data))
const CONTACTS = contactsRaw.map((data: ContactsData) => new SearchItem(data))
const DROPBOX = dropboxRaw.map((data: DropboxData) => new SearchItem(data))
const SLACK = slackRaw.map((data: SlackData) => new SearchItem(data))
const TWEET = tweetRaw.map((data: TweetData) => new SearchItem(data))

export { CALENDAR, CONTACTS, DROPBOX, SLACK, TWEET }
